import React, {useState, useRef, useEffect, Fragment, useMemo} from 'react';
import { ReactPDF, View, Page, Text, Image, Document, StyleSheet, Font } from "@react-pdf/renderer";
import { timePassed, unique } from '../../lib/utils';
import {BackButton} from '../frontend_components/BackButton';
import { useStateContext } from '../../context/StateContext';
//import { offerTableData } from '../../lib/offerTableData';
import { tableData } from '../offerComponents/CustomerProductsReport';
import { urlFor } from '../../lib/client';
import { offerTableData } from '../../lib/offerTableData';
import RichTextEditor from '../RichTextEditor';
import RedraftEditor from '../RedraftEditor';
import { euro, percentage, sortBySite, keyId } from '../../lib/utils';
import { offerTotals, sortByOrder, siteAddress, clientName } from '../../lib/utils';
//import { groupedOffer } from '../../pages/offers';
import { groupedOffer } from '../offerComponents/GroupedOffer';

const border = {color: "#474444", size: 1 } 


const styles = StyleSheet.create({
    body: {
      paddingTop: 20,
      paddingBottom: 20,
      paddingHorizontal: 20,
    },
    title: {
      fontSize: 10,
      textAlign: 'center',
      //fontFamily: 'Oswald'
    },
    author: {
      fontSize: 10,
      textAlign: 'center',
      marginBottom: 40,
    },
    siteTitle: {
        fontFamily: 'Open Sans',
        fontWeight:"bold",
        fontSize: 10,
        textAlign: "left",
        textDecoration: "underline",

    },
    registerTitle:{
        fontFamily: 'Open Sans',
        fontWeight:"bold",
        fontSize: 10,
        textAlign: "center",
        color:"red",
    },
    familyDevice:{
        marginLeft:"5px",
        fontFamily: 'Open Sans',
        fontWeight:"bold",
        fontSize: 10,
        textAlign: "left",
    },
    familyView:{
      minHeight: "20px",  
      backgroundColor: "#BEBCBC"
    },
    propertyView:{
        minHeight: "20px",  
        backgroundColor: "#dbdbdb"
      },
    subtitle: {
      fontSize: 10,
      margin: 5,
      //fontFamily: 'Oswald'
    },
    text: {
      margin: 12,
      fontSize: 10,
      textAlign: 'justify',
      fontFamily: 'Times-Roman'
    },
    image: {
      marginVertical: 15,
      marginHorizontal: 100,
    },

    header: {
      fontSize: 7,
      //textAlign: 'center',
      color: 'black',
      width:"100%",
      border: border.size,
      borderColor: border.color,
    },
        logoContainer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: border.size,
            borderBottomColor: border.color,
            padding: 5,
        },

            logo: {
                width: 200, 
                height: 26.6
            },

            signature: {
                width: 81, 
                height: 40
            },
        siteInfo: {
            display:"flex",
            flexDirection:"row",
            borderBottom: border.size,
            borderBottomColor: border.color,
            alignItems: "center",
            justifyContent:"center",
            padding:5
            
        },
        siteInfoSide:{
            display:"flex",
            flex:1,
            alignItems: "left",
            justifyContent:"left",
            textAlign: "left"
        },
        siteInfoCenter:{
            display:"flex",
            flex:1,
            alignItems: "center",
            justifyContent:"center",
            textAlign: "center"
            
        },
        siteInfoRight:{
            display:"flex",
            flex:1,
            alignItems: "flex-end",
            justifyContent:"right",
            textAlign: "right"
        },
        totalContainer: {
            //display:"flex",
            //backgroundColor:"blue"
            //alignItems: "right",
            //justifyContent:"right",
            //textAlign: "right"
        },
                registerHeaderField : {
                display: "flex",
                flexDirection:"row",
                //backgroundColor:"red",
                //width:"100%",
                //fontSize: 10,
                //flexWrap:"wrap",
                //alignItems: "center",
                justifyContent:"flex-end",
                //marginBottom:10,
                //textAlign: "right"
                //fontWeight: "extrabold",
                },

                    registerHeaderFieldTitle:{
                        fontFamily: 'Open Sans',
                        fontWeight: "light", 
                        //textDecoration:"underline",
                        //widht: 120,   
                        marginRight:5,  
       
                        //backgroundColor:"grey"
                    },
                    registerHeaderFieldData: {
                        fontFamily: 'Open Sans',
                        fontWeight: "bold", 
                        //width:"100%",
                        //backgroundColor:"blue",
                        marginRight:5,  
                        //backgroundColor:"red"
                    },

    tableHeader:{ 
        display:"flex",
        flexDirection:"row",
        alignItems:"center",
        justifyContent:"center",
        backgroundColor:"#385391",
        fontWeight:"bold",
        minHeight: 20,
        
    },

    tableFooter:{ 
        display:"flex",
        flexDirection:"row",
        alignItems:"center",
        justifyContent:"center",
        backgroundColor:"grey",
        minHeight: 20,
        color:"white",
        
    },
    tableColumn:{ 
        display:"flex",
     
        textAlign:"center",
        fontSize: 8,
        color:"white",
        alignItems:"center",
        justifyContent:"center",
        //left: "50%",
        //right:"50%",
        //paddingHorizontal:"2px",
        paddingVertical:"4px",
        overflow:"hidden",
        width:"100%",
        textOverflow:"ellipsis",
    },

    table:{ 
        display:"flex",
        
    },

    tableRow:{ 
        display:"flex",
        flexDirection:"row",
        alignItems:"center",
        justifyContent:"center",
        textOverflow:"ellipsis",
        minHeight: 20,

    },
    tableCell:{
        
        margin:"1px",
        textAlign:"center",
        //verticalAlign:"sub",
        overflow:"hidden",
        color:"#324d67",
        fontSize: 7,
        //display: "flex",
        //alignItems:"center",
        //justifyContent:"center",
        height: "100%",
        //width:"100%",
        //paddingHorizontal:"6px",
        padding:"5px",
        borderRight: border.size,
        borderRightColor: border.color,
        borderRightStyle: "dotted",
        //border: "1.5px solid red",
      
    },
    symbol: {
        width: 10, 
        height: 10, 
    },
    footerInfo: {
        display:"flex",
        flexDirection:"row",
        alignItems: "center",
        justifyContent:"center",
        padding:5,
        //backgroundColor:"red",
   
    },

    footerInfoRight:{
        display:"flex",
        flex:1,
        alignItems: "flex-end",
        justifyContent: "flex-end",
        textAlign: "right"
    },
    address: {
        //position: 'absolute',
        fontSize: 8,
        //bottom: 30,
        //left: 0,
        //right: 0,
        color: 'grey',
      },

    pageNumber: {
      //position: 'absolute',
      fontSize: 8,
      //bottom: 30,
      left: 0,
      right: 0,
      textAlign: 'center',
      color: 'grey',
    },
    summaryTitleContainer: {
        //position: 'absolute',
        marginTop: 10,
        marginBottom: 10,
        textAlign: 'center',
      },
  });

  /*
            <Text>{tableData.columns[0]}</Text>
            <Text>{tableData.columns[1]}</Text>
            <Text>{tableData.columns[2]}</Text>
    }
  */

//const rowColour = index % 2 ? "white":"#f3f4f3"

// Register Open Sans font - matching other PDF files
Font.register({
    family: 'Open Sans',
    fonts: [
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: "bold" }
    ]
    });

Font.registerHyphenationCallback(word => [word]);

// Global variable to track current document being processed
let currentProcessingDocument = null;

// Intercept Font.resolve to catch font resolution errors and log current document
const originalFontResolve = Font.resolve;
Font.resolve = function(...args) {
    try {
        return originalFontResolve.apply(this, args);
    } catch (error) {
        console.error('🚨 FONT RESOLUTION ERROR CAUGHT - THE PROBLEMATIC DOCUMENT:', {
            error: error.message,
            fontFamily: args[0]?.fontFamily,
            fontWeight: args[0]?.fontWeight,
            fontStyle: args[0]?.fontStyle,
            exactMomentOfFailure: Date.now(),
            FULL_PROBLEMATIC_DOCUMENT: currentProcessingDocument ? JSON.stringify(currentProcessingDocument.fullDocument, null, 2) : 'No document tracked',
            documentSummary: currentProcessingDocument ? {
                documentKey: currentProcessingDocument.documentKey,
                firstBlockText: currentProcessingDocument.firstBlockText,
                timestamp: currentProcessingDocument.timestamp
            } : null,
            stackTrace: error.stack
        });
        throw error; // Re-throw to maintain original behavior
    }
};

// Function to set current document being processed (browser only)
if (typeof window !== 'undefined') {
    window.setCurrentProcessingDocument = (doc) => {
        currentProcessingDocument = doc;
    };
}


const registerheaderField = (title, data, size=10) => { 
    
    return(
    <View debug={false}  style={{...styles.registerHeaderField, fontSize:size}}>
        <Text style={styles.registerHeaderFieldTitle}>{title}</Text>
        <Text style={styles.registerHeaderFieldData}>{data}</Text>
    </View>
) }

function compare( a, b ) {
    if ( a?.order < b?.order ){
      return -1;
    }
    if ( a?.order > b?.order ){
      return 1;
    }
    return 0;
  }



const indirizzo = (headerData) => (headerData.address1 + headerData.houseNumber + headerData.address2 + headerData.postcode + headerData.city) 

  
/**
 * A component that generates a PDF based on the data passed in.
 * #labourProducts #pdfOffer
 * @param {object} headerData - The header data for the PDF.
 * @param {object} data - The data to generate the PDF from.
 * @param {object} LDB - The LDB object to use for generating the PDF.
 * @returns {JSX.Element} - The generated PDF.
 */
const PdfOfferta = ({headerData, data={}, LDB}) => {

  
        const {sites, customer, registers, registerTemplates, generatedOffer, summaryData, client, isClientOrder} = data
        //console.log("IN CONSOLE GENERATED OFFER", generatedOffer?.filter?.((x)=>x?.offerPropertyId))
        const devices = useMemo(() => {
            return registers?.map?.((register)=>{
                const registerDevices = register?.devices?.map?.((registerDevice)=>({
                    ...registerDevice, 
                    registerId: register?._id, 
                    templateDeviceId: registerDevice?.templateDevice?._ref
                }))?.flat(2)
                return registerDevices
            })?.flat(2)
        }, [registers])

        const logoUrl = useMemo(() => customer && urlFor(customer?.logoHeader)?.url(), [customer])
        const signatureUrl = useMemo(() => customer && urlFor(customer?.signature)?.url(), [customer])
        const currentDate = useMemo(() => timePassed(Date.now(), true), [])
        
        const [workingData, setWorkingData] = useState()
        const hiddenColumns = useMemo(() => ["supplierPrice", "totalCost", "margin", "profit", "unitProfit", "lawLabel"], [])
        
        const filteredGeneratedOffer = useMemo(() => {
            const filterLabourAtZero = (x) => !(x?.labourProduct && x?.priceToClient == 0)
            return !Array.isArray(generatedOffer) ? [] : generatedOffer?.filter?.(filterLabourAtZero)
        }, [generatedOffer])
        const pdfData = useMemo(() => {
            if (!generatedOffer) return null
            return tableData(offerTableData(groupedOffer(filteredGeneratedOffer)), hiddenColumns)
        }, [filteredGeneratedOffer, hiddenColumns, generatedOffer])

        // Calculate total number of RedraftEditor documents for progress tracking
        const totalDocuments = useMemo(() => {
            if (!Array.isArray(filteredGeneratedOffer)) return 0;
            
            let count = 0;
            filteredGeneratedOffer.forEach(item => {
                // Count law fields
                if (item?.law?.blocks?.length > 0) count++;
                // Count description fields
                if (item?.description?.blocks?.length > 0) count++;
            });
            
            return count;
        }, [filteredGeneratedOffer]);

        useEffect(() => {
            setWorkingData(pdfData)
            console.log("lsmcflsdkmcsdlkmds", {generatedOffer})
            
            // Set total document count for progress bar
            if (totalDocuments > 0 && typeof window !== 'undefined' && window.setPdfTotalDocuments) {
                window.setPdfTotalDocuments(totalDocuments);
            }
        }, [pdfData, totalDocuments])


        //callBack({...data,devices})

        //const allTableData =  tableData(allRegistersGeneratedOffer)

    /*     const orderedColumns = !tableData?.columns ? [] : tableData?.columns?.map?.((item)=>{
            const order = () => {
              if(item.accessor == "presidio") return 5
              if(item.accessor == "esito") return 99
              if(item.accessor == "nonConformita") return 98
              if(item.accessor == "_id") return 0
        
              return item?.order
            }
          return(
          {
            ...item,
            order: order()
          }
        )}) */
    
        //console.log("orderColumns", orderedColumns)
    
    
    /*     const clientName = () => {
            
            if(!headerData.notComune) return `COMUNE DI ${headerData.client}`
            return headerData.client
          } */
    
    
        const columnSize = useMemo(() => {
            return (item) => {
                const columnFlex = (item) => {
                    if(item.accessor=="law") return 7
                    if(item.accessor=="description") return 2.5
                    if(item.accessor=="location") return 1
                    return 1  
                }
                
                const columnMaxWidth = (item) => {
                    if(item?.maxWidth) return ({maxWidth: item?.maxWidth })
                    return {}  
                }
                
                const columnMinWidth = (item) => {
                    if(item.accessor == "esito") return ({minWidth: 16 })
                    if(item?.minWidth) return ({minWidth: item?.minWidth })
                    if(item.accessor == "presidio") return ({minWidth: 30})
                    if(item.accessor == "site") return ({minWidth: 60})
                    if(item.accessor.startsWith("ddl-")) return ({minWidth: 20})
                    return {minWidth: 20}   
                }
                
                return {
                    ...columnMaxWidth(item), 
                    ...columnMinWidth(item), 
                    flex: columnFlex(item)
                }
            }
        }, [])
        const clientLabel = headerData?.clientLabel
        const addressLabel = headerData?.addressLabel 

        const orderedColumns = useMemo(() => {
            if (!summaryData?.columns) return []
            return summaryData.columns.map?.((item) => {
                const order = () => {
                    if(item.accessor == "signs") return 98
                    if(item.accessor == "totals") return 99
                    if(item.accessor == "site") return 0
                    return item?.order
                }
                return {
                    ...item,
                    order: order()
                }
            })
        }, [summaryData?.columns])

        const LOGO_HEADER = 
        <View wrap={false} style={styles.header} fixed>
            <View style={styles.siteInfo}>
                <View style={styles.siteInfoSide}>
                    <Image
                        style={{
                            width: customer?.logoHeaderSize?.width, 
                            height: customer?.logoHeaderSize?.height, 
                        }}

                        layout="fill"
                        src={logoUrl}
                    />   
                </View>
                <View style={styles.siteInfoCenter}> 
                </View>
                <View style={styles.siteInfoRight}>
                    <Text style={styles.text}>
                        {currentDate}
                    </Text>
                    <Text style={styles.text}>
                        {isClientOrder ? "ORDINE" : "OFFERTA"}
                    </Text>
                </View>
            </View>
        </View>

        const SIGNATURE_FOOTER = 
        <View fixed  style={styles.footerInfo}>
            <View  style={styles.siteInfoSide}>  
            </View>
            <View style={styles.siteInfoCenter}>
                <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                    `${pageNumber} / ${totalPages}`
                )} />   
            </View>
            <View style={styles.footerInfoRight}>
                {   
                    signatureUrl && <Image
                    style={styles.signature}
                    src={signatureUrl}
                /> }  
            </View>
        </View>
    
        return (
    <Document> 
        <Page style={styles.body} orientation='landscape'>
            {LOGO_HEADER}
            <View fixed style={styles.tableHeader}>
                {workingData?.columns?.sort(compare).map?.((item, index)=>{
                    if(workingData?.hideColumns?.some?.((y)=>item?.accessor==y)) return undefined
                    return(
                        <View key={index} style={{...styles.tableColumn, ...columnSize(item)}}>
                            <Text styles={styles.text} >{item?.Header}</Text>
                        </View>
                )})}
            </View>
                <View style={styles.table}>
                    {
                        sites?.map?.((site, index)=>{
                            
                            const filtertedSiteData = useMemo(() => {
                                return !Array.isArray(filteredGeneratedOffer) ? [] : 
                                    filteredGeneratedOffer?.filter?.((x)=>x?.siteId == site?._id && !x?.isSign)
                            }, [filteredGeneratedOffer, site._id])
                            
                            const isThereData = useMemo(() => dataExists(filtertedSiteData?.filter((x)=>!x?.hide)), [filtertedSiteData])

                            const siteSignsData = useMemo(() => {
                                return !Array.isArray(filteredGeneratedOffer) ? [] : 
                                    filteredGeneratedOffer?.filter?.((x)=>x?.siteId == site?._id && x?.isSign)
                            }, [filteredGeneratedOffer, site._id])

                            const {
                                signsNoLabourTableData,
                                signsLabourTableData,
                                isThereSignsData
                            } = useMemo(() => {
                                const siteSignDataWithoutLabourProduct = !Array.isArray(siteSignsData) ? [] : 
                                    siteSignsData?.filter?.((x)=>!x?.labourProduct)
                                const siteSignDataLabourProducts = !Array.isArray(siteSignsData) ? [] : 
                                    siteSignsData?.filter?.((x)=>x?.labourProduct)
                                
                                return {
                                    signsNoLabourTableData: tableData(offerTableData(groupedOffer(siteSignDataWithoutLabourProduct)), hiddenColumns),
                                    signsLabourTableData: tableData(offerTableData(groupedOffer(siteSignDataLabourProducts)), hiddenColumns),
                                    isThereSignsData: dataExists(siteSignsData?.filter((x)=>!x?.hide))
                                }
                            }, [siteSignsData, hiddenColumns])

                            const siteRegisters = useMemo(() => {
                                if (!Array.isArray(registers)) return []
                                return registers
                                    ?.filter?.((x)=>x?.site?._ref == site?._id)
                                    ?.map?.((item)=>{
                                        const registerTemplate = !Array.isArray(registerTemplates) ? undefined : 
                                            registerTemplates?.find?.((x)=>x?._id == item?.template?._ref)
                                        return ({...item, order: registerTemplate?.order})
                                    })
                            }, [registers, registerTemplates, site._id])
                            //console.log(siteRegisters)
                            const siteTotals = useMemo(() => {
                                const signsRegisterTotalAsNumber = offerTotals(siteSignsData)?.priceToClient
                                const signsRegisterTotal = euro(offerTotals(siteSignsData)?.priceToClient)
                                const siteTotal = euro(offerTotals(filtertedSiteData)?.priceToClient + offerTotals(siteSignsData)?.priceToClient)
                                
                                return {
                                    signsRegisterTotalAsNumber,
                                    signsRegisterTotal,
                                    siteTotal
                                }
                            }, [siteSignsData, filtertedSiteData])

                            const {signsRegisterTotalAsNumber, signsRegisterTotal, siteTotal} = siteTotals
                            //console.log("IN CONSOLE OFFER PDF", {label:site?.label,isThereData,isThereSignsData, filtertedSiteData, siteSignsData })
                            if(!isThereData && !isThereSignsData ) return undefined
                            return(
                                <>
                                <View key={index}>
                                    {
                                    siteRegisters?.sort(sortByOrder)?.map?.((register, index)=>{
                                        const registerTemplate = !Array.isArray(registerTemplates) ? undefined : registerTemplates?.find?.((x)=>x?._id == register?.template?._ref)
                                        const registerTitle = registerTemplate?.offerTitle ? registerTemplate?.offerTitle : register?.label

                                        const uniqueDevicesInRegister1 = devices && unique("templateDeviceId",!Array.isArray(devices) ? [] : devices?.filter?.((x)=>x?.registerId == register?._id))?.map?.((item)=>{
                                            const templateDevice = !Array.isArray(registerTemplate?.devices) ? undefined : registerTemplate?.devices?.find?.((x)=>x?._id ==  item.templateDeviceId)
                                            const order = templateDevice?.order ? templateDevice?.order : 99
                                            const doc = {...item, order}
                                            //console.log("itemizing", doc, templateDevice )
                                            return doc

                                        })
                                        const uniqueDevicesInRegister = !Array.isArray(generatedOffer) ? [] : unique("deviceFamilyId", generatedOffer)?.map?.((item)=>{
                                            const templateDevice = !Array.isArray(registerTemplate?.devices) ? undefined : registerTemplate?.devices?.find?.((x)=>x?._id == item?.deviceFamilyId)
                                          
                                            const order = templateDevice?.order ? templateDevice?.order : 99
                                            //console.log("ldmaksmxalskmaklsmx", {templateDevice, item, order, registerTemplate})
                                            if(!item?.deviceFamilyId) return
                                            const doc = { _key: item?._key, order, templateDeviceId: item?.deviceFamilyId, templateDevice:{_ref: item?.deviceFamilyId, _type:"reference",_key: keyId()}}
                                            return doc
                                        })?.filter?.((x)=>x)
                                          

                                        const registerFilteredData = !Array.isArray(filtertedSiteData) ? [] : filtertedSiteData?.filter?.((x)=>{
                                            return(
                                                 x?.registerId == register?._id
                                            )
                                        })
                                        const thereIsData = dataExists(registerFilteredData)
                                        const noFamilyRegisterData = registerFilteredData?.sort(sortByOrder)?.filter?.((x)=>(!x?.deviceFamilyId || x?.labourProduct) && !x?.hide)
                                        const thereIsDataNoFamilyData = dataExists(noFamilyRegisterData)
                                        const noFamilyTableData = tableData(offerTableData(groupedOffer(noFamilyRegisterData)), hiddenColumns)
                                        //#offerTotals
                                        const totalAsNumber = Number(offerTotals(registerFilteredData)?.priceToClient)
                                        const registerTotal = euro(offerTotals(registerFilteredData)?.priceToClient)
                                        //console.log("IN CONSOLE REGISTER DATA", noFamilyRegisterData)

                                        if(totalAsNumber==0) return undefined
                                        return (
                                        <>
                                        <View key={index}>
                                            <View fixed>
                                                <RegisterHeader siteAddress={siteAddress(site)} clientName={clientName(client)} siteName={site?.label} registerTitle={registerTitle}/>
                                            </View>
                                           
                                            <View>
                                                {uniqueDevicesInRegister?.sort(sortByOrder)?.map?.((deviceFamily, index)=>{
                                                      
                                                    //console.log("IN CONSOLE DEVICE FAMILY", deviceFamily)
                                                    const deviceFamilyData = useMemo(() => {
                                                        const deviceTemplate = !Array.isArray(registerTemplate?.devices) ? undefined : 
                                                            registerTemplate?.devices?.find?.((x)=>x?._id == deviceFamily?.templateDeviceId)
                                                        
                                                        const filteredData = registerFilteredData?.sort(sortByOrder)?.filter?.((x)=>
                                                            !x?.labourProduct && x?.deviceFamilyId == deviceFamily?.templateDeviceId
                                                        )
                                                        
                                                        const uniqueOfferProperties = unique("offerPropertyId", filteredData)
                                                            ?.filter?.(x=>x?.offerPropertyId)
                                                            ?.map?.((x)=>({
                                                                id: x?.offerPropertyId, 
                                                                label: x?.offerPropertyLabel, 
                                                                isOfferProperty: true
                                                            }))
                                                        
                                                        const mainTableData = tableData(
                                                            offerTableData(
                                                                groupedOffer(
                                                                    filteredData?.filter?.((x)=>!x?.offerPropertyId)
                                                                )
                                                            ), 
                                                            hiddenColumns
                                                        )
                                                        
                                                        return {
                                                            deviceTemplate,
                                                            filteredData,
                                                            uniqueOfferProperties,
                                                            mainTableData,
                                                            thereIsData: dataExists(filteredData)
                                                        }
                                                    }, [registerTemplate?.devices, deviceFamily?.templateDeviceId, registerFilteredData, hiddenColumns])

                                                    const {
                                                        deviceTemplate,
                                                        filteredData,
                                                        uniqueOfferProperties,
                                                        mainTableData,
                                                        thereIsData
                                                    } = deviceFamilyData
                                                    //
                                                    
                                                    //console.log("IN CONSOLE PDF OFFER PROPERTY", filteredData)
                                                    //console.log("deviceTemplate:", deviceTemplate)
                                                    if(!thereIsData) return undefined
                                                    return (
                                                        <>
                                                        <OfferTable 
                                                            key={index}
                                                            tableData={mainTableData} 
                                                            deviceTemplate={deviceTemplate}
                                                            columnSize={columnSize}
                                                        />
                                                        {uniqueOfferProperties?.length >0 && uniqueOfferProperties?.map?.((propertyObj)=>{
                                                            const propertyData = useMemo(() => {
                                                                const offerDataByProperty = filteredData.filter?.((x)=>x?.offerPropertyId == propertyObj?.id)
                                                                return tableData(offerTableData(groupedOffer(offerDataByProperty)), hiddenColumns)
                                                            }, [filteredData, propertyObj?.id, hiddenColumns])

                                                            //console.log("IN CONSOLE PDF DATA", offerDataByProperty?.filter?.((x)=>x?._id == "ecf9d57f-a05d-45b9-a2a6-773d428b14c8"))
                                                            return (
                                                            <>
                                                            { propertyObj?.id &&
                                                                <OfferTable 
                                                                key={index}
                                                                tableData={propertyData} 
                                                                deviceTemplate={propertyObj}
                                                                columnSize={columnSize}
                                                                /> }
                                                            </>
                                                            )})}
                                                        </>
                                                    )
                                                })}     
                                                
                                                { thereIsDataNoFamilyData &&
                                                        <OfferTable 
                                                            tableData={noFamilyTableData} 
                                                            columnSize={columnSize}
                                                        />
                                                    }
                                                <View style={styles.totalContainer}>
                                                    {registerheaderField (`TOTALE ADEGUAMENTO ${registerTitle}:`,registerTotal, 12)}
                                                </View>     
                                            </View>
                                        </View>
                                        <View break></View>
                                        </>
                                    )

                                })
                                }
                                { signsRegisterTotalAsNumber !== 0 &&
                                    <View>
                                        <View fixed>
                                            <RegisterHeader siteAddress={siteAddress(site)} clientName={clientName(client)} siteName={site?.label} registerTitle={"SEGNALETICA"}/>
                                        </View>
                                        
                                        <OfferTable 
                                                tableData={signsNoLabourTableData} 
                                                columnSize={columnSize}
                                            />
                                        <OfferTable 
                                                tableData={signsLabourTableData} 
                                                columnSize={columnSize}
                                            />
                                        <View style={styles.totalContainer}>
                                            {registerheaderField ("TOTALE ADEGUAMENTO SEGNALETICA:",signsRegisterTotal, 12)}
                                        </View> 
                                    </View> 
                                }
                                <View style={styles.totalContainer}>
                                    {registerheaderField (`TOTALE ADEGUAMENTO PLESSO ${site?.siteNumber}:`,siteTotal, 12)}
                                </View> 
                               
                            </View>
                            <View break></View>
                            </>
                            )
                        }
                    )
                    }
            </View> 
            {SIGNATURE_FOOTER}
        </Page>
        <Page style={styles.body} orientation='landscape'>
            {LOGO_HEADER}
            <View style={styles?.summaryTitleContainer}>
               <Text>RIEPILOGO ADEGUAMENTI</Text>
            </View>
            
            <View wrap={false} fixed style={styles.tableHeader}>
                {orderedColumns.sort(compare).map?.((item, index)=>{
                    return(
                        <Text key={index} style={{...styles.tableColumn, ...columnSize(item)}}>{`${item?.Header}`}</Text>
                )})}
            </View>
            <View style={styles.table}>
            { summaryData?.data &&  summaryData?.data?.sort(sortBySite)?.map?.((row, index)=>{
                const rowColour = index % 2 ? "white":"#f3f4f3"
                if(!row?.totals || row?.totals == 0) return
                //console.log("ROW", row)
                return (
                    <View wrap={false} key={index} style={[ styles.tableRow, {backgroundColor: rowColour}]}>
                        {orderedColumns?.sort(compare).map?.((item, index)=>{
                            const value = () => {
                              
                                if(item?.accessor == "site") return row[item?.accessor]
                                if(!row[item?.accessor]) return ""
                                return euro(+row[item?.accessor])

                        }
                            return <Text wrap={false} key={index} style={{...styles.tableCell, ...columnSize(item)}}>{value()}</Text>               
                        })}
                    </View>
                )
            })
            }
            </View>
            <View wrap={false} style={styles.tableFooter}>
                {orderedColumns.sort(compare).map?.((item, index)=>{
                const value = () => {
                    if(item?.accessor == "site") return item?.Footer
                    return euro(item?.Footer)

                }
                    return(
                        <Text key={index} style={{...styles.tableColumn, ...columnSize(item)}}>{value()}</Text>
                )})}
            </View>
            {SIGNATURE_FOOTER}
        </Page>
    </Document>
      );
    } 

export default PdfOfferta

export const dataExists = (array) => {
    if(array?.length > 0) return true
    return false
}


export const OfferTable = ({tableData, deviceTemplate, columnSize, customHeader}) => {
      const subtitleHeader = !deviceTemplate?.isOfferProperty ? styles.familyView : styles.propertyView
      
    return(
        <View> 
            <View  style={subtitleHeader}>
            <Text  style={styles.familyDevice}>{customHeader ? customHeader : deviceTemplate?.label}</Text>
        </View>

        <View style={styles.table}>
            {tableData?.data && tableData?.data?.sort(sortByOrder)?.map?.((row, index)=>{ 
            const rowColour = index % 2 ? "white":"#f3f4f3"
            return (
                <View wrap={false} key={index} style={[ styles.tableRow, {backgroundColor: rowColour}]}>
                    {tableData?.columns?.sort(compare).map?.((item, index)=>{
                
                        const value = () => {
                            if (item?.accessor == "law" || item?.accessor == "description"){ 
                                // Commented out document logging for cleaner console - uncomment for debugging
                                // if (row[item?.accessor]) {
                                //     console.log(`🔥 PDF OFFERTA: Processing ${item?.accessor} field with document:`, {
                                //         hasBlocks: !!row[item?.accessor]?.blocks,
                                //         blockCount: row[item?.accessor]?.blocks?.length,
                                //         firstBlockText: row[item?.accessor]?.blocks?.[0]?.text?.substring(0, 100) + '...',
                                //         documentKey: row[item?.accessor]?.blocks?.[0]?.key,
                                //         fullDocument: JSON.stringify(row[item?.accessor], null, 2)
                                //     });
                                // }
                                return(                                                                    
                            <View  wrap={false} key={index} style={{...styles.tableCell, ...columnSize(item),}}>
                                {row[item?.accessor] && <RedraftEditor existingDoc={row[item?.accessor]}/>}
                            {/*  { row[item?.accessor]?.blocks[0]?.text} */}
                            </View> 
                            )}
                        //console.log("FORMATTED", item)
                        const formattedValue = (value) => {
                            if(item?.accessor == "quantity" && item?.labourProduct) return 1
                            if (item?.accessor == "discount") return percentage(value)
                            if (item?.accessor == "priceToClient") return euro(value)
                            if (item?.accessor == "discountedUnitPrice") return euro(value)
                            if (item?.accessor == "unitPrice") return euro(value)
                            if (item?.accessor == "pricelistCode") return "LISTINO"
                            return value 
                        }
                        return (
                            <Text wrap={false} key={index} style={{...styles.tableCell, ...columnSize(item)}}>
                                { formattedValue(row[item?.accessor])}
                            </Text> 
                        )}

                    if(tableData?.hideColumns.some?.((y)=>item.accessor==y)) return undefined
                    return (
                        value())           
                    })}
                </View>
                )
            })}
        </View> 
    </View>
    )
} 

export const RegisterHeader = ({siteName, siteAddress, registerTitle, clientName}) => {

    return (
        <View style={styles.siteInfo}>
            <View style={styles.siteInfoSide}>
                <Text style={styles.siteTitle}>
                    {siteName}
                </Text>
                <Text style={styles.address}>
                    {siteAddress}
                </Text>
            </View>
            <View  style={styles.siteInfoCenter}>
                <View >
                    <Text style={styles.registerTitle}>
                        {registerTitle}
                    </Text>
                </View>
            </View>
            <View  style={styles.siteInfoRight}>
                <Text style={styles.siteTitle}>
                    {clientName}
                </Text>
            </View>
        </View>
    )
}
